export const ACCESS_TOKEN = 'kl-access-token'
export const KL_REFRESH_TOKEN = 'kl-refresh-token'
export const USER_INFO = 'user_info'
export const USER_SYSTEM_ROLE = 'user-system-role' // 服务商 | 品牌方
export const USER_ID = 'user_id' // 用户id
export const USER_MENUS = 'user_menus'
export const TEAM_CURT_INFO = 'team_curt_info'
export const PROJECT_CURT_BIG_TYPE = 'project_curt_big_type'
export const PROJECT_CURT_SMALL_TYPE = 'project_curt_small_type'
export const PLAN_CURT_SELECT_PROJECT = 'plan_curt_select_project'
export const PROCESS_ALL_KIND = 'process_all_kind'
export const PROCESS_ALL_KIND_BRAND = 'process_all_kind_brand'
export const USER_BUTTONS = 'user_buttons'
export const MODULE_ID = 'moduleId'
export const UPLOAD_URL = '/openx-resource/oss/endpoint/put-file'
export const DETAIL_INFO = 'detailInfo'
export const KL_THEME = 'kl_theme'

export const PROJECT_OR_PLAN_PROCESS_MODULE_SEARCH = 'project_or_plan_process_module_search'

export const PROJECT_PROCESS_MODULE_SEARCH_ALL = 'project_process_module_search_all'
export const PROJECT_PROCESS_MODULE_SEARCH_MAIL = 'project_process_module_search_mail'
export const PROJECT_PROCESS_MODULE_SEARCH_MANUSCRIPT = 'project_process_module_search_manuscript'
export const PROJECT_PROCESS_MODULE_SEARCH_PUT_DATA = 'project_process_module_search_put_data'
export const PROJECT_PROCESS_MODULE_SEARCH_PUT_REPORT = 'project_process_module_search_put_report'

export const BRAND_PROCESS_MODULE_SEARCH_ALL = 'brand_process_module_search_all'
export const BRAND_PROCESS_MODULE_SEARCH_MAIL = 'brand_process_module_search_mail'
export const BRAND_PROCESS_MODULE_SEARCH_MANUSCRIPT = 'brand_process_module_search_manuscript'
export const BRAND_PROCESS_MODULE_SEARCH_PUT_DATA = 'brand_process_module_search_put_data'
export const BRAND_PROCESS_MODULE_SEARCH_PUT_REPORT = 'brand_process_module_search_put_report'

export const PROJECT_AUDIT_MODULE_SEARCH_MANUSCRIPT = 'project_audit_module_search_manuscript'
export const PROJECT_AUDIT_MODULE_SEARCH_PUT_REPORT = 'project_audit_module_search_put_report'
export const BRAND_AUDIT_MODULE_SEARCH_MANUSCRIPT = 'brand_audit_module_search_manuscript'
export const BRAND_AUDIT_MODULE_SEARCH_PUT_REPORT = 'brand_audit_module_search_put_report'

export interface IPageAndSizeKey {
  PAGE_KEY: string
  SIZE_KEY: string
}
export const PAGE_SIZE_COMMON_KEY: IPageAndSizeKey = {
  PAGE_KEY: 'pageNo',
  SIZE_KEY: 'pageSize'
}
